import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

// サインイン画面とホーム画面にて、
// キャンペーンに応じてデフォルトの言語を選ぶようにするhook
export const useChangeLanguage = ({ campaign }: { campaign: Api.CampaignResBody }) => {
  const { i18n } = useTranslation()

  useEffect(() => {
    if (campaign && campaign.languages.length > 1) {
      // 多言語化対応している場合
      const i18nextLng = localStorage.getItem('i18nextLng')
      if (!i18nextLng) {
        localStorage.setItem(`i18nextLng`, 'ja_JP')
        i18n.changeLanguage('ja_JP')
      }
    } else {
      // 多言語化対応していない場合
      // 強制的に日本語に設定する
      localStorage.setItem(`i18nextLng`, 'ja_JP')
      i18n.changeLanguage('ja_JP')
    }
  }, [campaign])
}
